import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IoMdAdd } from 'react-icons/io'
import { Pagination } from 'antd'
import { useNavigate, Route, Routes, useLocation } from 'react-router-dom'
import AdminForm from './AdminForm'
import AdminDetails from './AdminDetails'
import AdminListItem from './AdminListItem'
import { NotAdminPlaceHoldersvg, AdminsIcon } from '../../../assets/icons'
import { SearchBar, Button, Spinner } from '../../../UI'
import { getAllAdmins } from '../../../store/actions'
import Container from './styles'

const Admins = () => {
  const [loading, setLoading] = useState(true)
  const [searchVal, setSearch] = useState('')
  const { AdminData } = useSelector((s) => s)
  const [adminLists, setAdminLists] = useState(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  
  useEffect(() => {
    // Refetch admins when we're on the main admin list path
    if (location.pathname === '/dashboard/admins') {
      setLoading(true)
      dispatch(getAllAdmins())
        .finally(() => {
          setLoading(false)
        })
    }
  }, [dispatch, location.pathname])

  useEffect(() => {
    if (AdminData?.adminLists) {
      setAdminLists(AdminData.adminLists)
    }
  }, [AdminData])

  const handleSearch = () => {
    setLoading(true)
    dispatch(getAllAdmins(1, 10, searchVal))
      .then((response) => {
        if (response) {
          setAdminLists(response)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Container>
      <Routes>
        <Route
          path=":adminId/details"
          element={<AdminDetails />}
        />
        <Route
          path=":action"
          element={<AdminForm />}
        />
        <Route path="/" element={
          <>
            <header>
              <div className="top--row">
                <h2>Admins</h2>
                <AdminsIcon />
              </div>
              <div className="header--row">
                <SearchBar
                  placeholder="Search by names"
                  handleSearch={handleSearch}
                  onChange={(e) => {
                    setSearch(e.target.value)
                  }}
                />
                <Button
                  className="add--btn"
                  onClick={() => navigate('/dashboard/admins/add')}
                >
                  <IoMdAdd />
                  Add Admin
                </Button>
              </div>
            </header>
            <div className="admin--content__container">
              {loading ? (
                <div className="loading-container">
                  <Spinner size={'70px'} />
                  <p>
                    {searchVal ? `Searching for ${searchVal}` : 'Loading admins...'}
                  </p>
                </div>
              ) : (
                <>
                  <div className="admin--lists--container">
                    {adminLists && adminLists.data && adminLists.data.length > 0
                      ? adminLists.data.map((item) => (
                          <AdminListItem
                            key={item.id}
                            {...item}
                            onClick={() => {
                              navigate(
                                `/dashboard/admins/${item.id}/details`,
                              )
                            }}
                          />
                        ))
                      : !loading && (
                          <div className="noAdminList--container">
                            <NotAdminPlaceHoldersvg />
                            <h3>No admin added</h3>
                            <p className="instruction">
                              You are permitted to add <span>10 admins</span> only as
                              a super admin
                            </p>
                            <Button
                              onClick={() => navigate('/dashboard/admins/add')}
                            >
                              <IoMdAdd />
                              Add admin
                            </Button>
                          </div>
                        )}
                  </div>
                </>
              )}
              
            </div>
          </>
        } />
      </Routes>
    </Container>
  )
}

export default Admins
